import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postStartMigration = (token, tenantId) => {
    return fetch(`${apiUrl}start_migration/${tenantId}`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
        },
    });
}

export default postStartMigration
